import { render, staticRenderFns } from "./AssessmentPage.vue?vue&type=template&id=6e97cea6"
import script from "./AssessmentPage.vue?vue&type=script&lang=js"
export * from "./AssessmentPage.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPage.vue?vue&type=style&index=0&id=6e97cea6&prod&scroped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports